module.exports = __webpack_public_path__ + "img/aero-shot-3.4088e168.webp";